import { IAdherent } from './adherent.model';
import { RoleNavigationMarinEnum } from '../constant/enum';

export interface ICampModuleMarinEncadrantNautique {
  id?: number;
  adherent?: IAdherent;
  roleNavigationMarin?: RoleNavigationMarinEnum;
}

export class CampModuleMarinEncadrantNautique implements ICampModuleMarinEncadrantNautique {
  constructor(
    public id?: number,
    public adherent?: IAdherent,
    public roleNavigationMarin?: RoleNavigationMarinEnum
  ) {
  }
}
